import React from 'react';

export default function Toast({ message }) {
  if (!message) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="fixed bottom-4 right-4 z-50 pointer-events-none max-w-sm px-4 py-3 bg-retro-surface border-2 border-retro-cyan text-retro-text text-sm font-semibold shadow-lg retro-glow"
    >
      {message}
    </div>
  );
}
